import { handleActions } from 'redux-actions';
import * as mailActions from '../actions/mail';

let initState = {
  history: [],
  sendingResult: {
    count: 0,
  },
};

export const mail = handleActions(
  {
    [mailActions.getAllMailHistory]: state => {
      return { ...state, isLoadingHistory: true };
    },
    [mailActions.getAllMailHistorySuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        history: payload,
        isLoadingHistory: false,
      };
    },
    [mailActions.getAllMailHistoryError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        isLoadingHistory: false,
      };
    },
    [mailActions.mailSend]: state => {
      return { ...state, isLoadingMailSend: true };
    },
    [mailActions.mailSendSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        sendingResult: {
          ...payload,
          count: state.sendingResult.count + 1,
        },
        history: [payload.data, ...state.history],
        isLoadingMailSend: false,
      };
    },
    [mailActions.mailSendError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        isLoadingMailSend: false,
      };
    },
  },
  initState
);
